import FormattedMessage from 'I18n/components/FormattedMessage';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const GoToActionDetail = ({
  messageLangPath = 'actionDetail',
  nextActionType
}) => {
  if (nextActionType === ActionTypes.WHILE_LOOP) {
    return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.go-to.action-detail.while-loop"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.go-to.action-preview.while-loop"
    });
  }
  return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.go-to.action-detail.default"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.go-to.action-preview.default"
  });
};
export default GoToActionDetail;